import Modal from 'react-bootstrap/Modal';
import Button from "../Button";
import { useSelector } from "react-redux";
import { selectTranslations } from "../../services/i18n/i18nSlice";

import './modalStyle.css'

export default function ConfirmModal ({props}) {

    const {show, onConfirm, onClose, icon, title, text, confirmCta, closeCta} = props
    const t = useSelector(selectTranslations)

    return (
        <Modal
            show={show}
            onHide={onClose}
            keyboard={false}
            centered
        >
            <Modal.Body>
                <h2 className="text-center">{title}</h2>
                <p className="text-center mb-4">{text}</p>
                {onConfirm !== null ? 
                    <button className="mt-2 mx-auto" onClick={onConfirm} >{confirmCta || t.modals.confirm}</button>
                    : null
                }
                {onClose !== null ? 
                    <button className="mt-2 secondary mx-auto" onClick={onClose} >{closeCta || t.modals.close}</button>
                    : null
                }
            </Modal.Body>
        </Modal>
    )
}